import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageBoxOption } from '../../models/message-box/message-box-option';
import { PopupType } from '../../types/popup/popup-type';
import { PopupComponent } from '../popup/popup.component';

@Component({
  selector: 'tcat-message-box',
  templateUrl: './message-box.component.html',
  styleUrls: ['./message-box.component.scss']
})
export class MessageBoxComponent implements OnInit {

  popupType = PopupType.XSMALL;

  @ViewChild(PopupComponent)
  popup!: PopupComponent;

  zIndex = 8000;

  private resolveFn: any = null;
  private rejectFn: any = null;



  title!: string;
  messages: string[] = [];
  options?: MessageBoxOption[];


  constructor() { }

  ngOnInit(): void {
  }

  showMessage(title: string, message: string, options: Array<MessageBoxOption>): Promise<MessageBoxOption> {

    this.popup.show();
    this.title = title;
    this.messages = message == null ? [] : message.split('\n');
    this.options = options;
    return new Promise((resolve, reject) => {
      this.resolveFn = resolve;
      this.rejectFn = reject;
    });
  }

  onOptionSelected(option: MessageBoxOption) {
    this.resolveFn(option);
    this.hide();
  }

  cancel() {
    this.rejectFn('close');
    this.hide();
  }

  
  hide() {
    this.popup.hide();
  }

}
